import React from "react";

const Decoration1 = () => {
  return (
    <div className="py-3">
      <img
        src="https://templates.microweber.com/wedding/userfiles/templates/wedding/assets/img/decoration-1.svg"
        alt="decoration-1"
        className="max-h-[40px] max-w-[500px] m-auto w-3/4 md:w-full"
      ></img>
    </div>
  );
};

export default Decoration1;
